import { HTMLProps } from 'react';
import classnames from 'classnames';

type HTMLParagraphProps = Omit<HTMLProps<HTMLParagraphElement>, 'size'>;

interface ParagraphProps extends HTMLParagraphProps {
  size?: 'small' | 'large';
}

export default function Paragraph({
  children,
  className,
  size = `large`,
  ...props
}: ParagraphProps) {
  return (
    <p
      className={classnames(`leading-loose`, className, {
        'my-1 md:my-2 lg:my-4 text-sm': size === `small`,
        'my-3 md:my-4 lg:my-6': size === `large`,
      })}
      {...props}
    >
      {children}
    </p>
  );
}
